module.exports = __webpack_public_path__ + "img/tg_explain.11a100ce.png";